<template>
  <div class="">
    <div class="text-right mb-2">
      <span>
        Viendo documentos que ingresaron
      </span>
      <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span>
      <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
        <datetimef
          v-model="rangeFrom"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="dd-MM-yyyy"
          data-cy="start-time"
        />
        y el
        <datetime
          v-model="rangeUntil"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="dd-MM-yyyy"
          data-cy="end-time"
        />
        <span>
          <vs-button
            radius
            class="ml-3 d-inline"
            color="primary"
            type="border"
            icon="search"
            size="small"
            @click="changeFilters(currentFilters)"
            data-cy="filter-by-date"
          />
        </span>
      </span>
      <vs-dropdown vs-trigger-click
                   style="margin-left: 15px"
                   data-cy="change-date">
        <a class="a-icon" href="#">
          Cambiar
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-dropdown-item
            style="width:200px"
            v-for="range in ranges"
            :key="range.valor"
            v-on:click.native="selectRange(range)"
            data-cy="change-date-item"
          >
            {{ range.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <filters
      :filtersView="filterView"
      :periodos="ranges"
      :documentType="documentType"
      :entities="entity"
      :has-query-filters="!!queryFilters"
      :clear-query-filters="clear"
      v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltersDntMixin from '@/febos/chile/dnt/mixins/FiltersDntMixin';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { DATE_RANGE_LAST_2_YEARS, DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';
import Filters from '@/febos/chile/docDigital/components/Filters';
import ConfigDocDigitalFiltersMixin from '@/febos/chile/docDigital/components/ConfigDocDigitalFiltersMixin';
import { listOptions } from '@/febos/servicios/api/docDigital.api';

export default {
  components: { Filters },
  props: ['value', 'onChange', 'clear', 'defaultDate', 'fechaName', 'fechaUntilName'],
  mixins: [FiltersDntMixin, FindTypeDocumentMixin, ConfigDocDigitalFiltersMixin, SelectorDateMixin],
  data() {
    const { view } = this.$route.params;
    const range = this.defaultDate ? this.defaultDate : DATE_RANGE_LAST_2_YEARS;
    return {
      ranges: DATE_RANGES,
      rangeFrom: '',
      rangeSelected: range,
      rangeUntil: '',
      view,
      currentFilters: '',
      queryFilters: this.$route.query.filters,
      myEntities: []
    };
  },
  async created() {
    this.selectRange(this.rangeSelected, true);
    console.log('created: this.rangeFrom', this.rangeFrom, 'this.rangeUntil', this.rangeUntil);
    await this.fetchOptionsDocDigital();
    const response = await listOptions({
      params: {
        metodo: 'GET',
        api: '/api/entidades/token/'
      },
      body: {
        params: {}
      }
    });
    this.myEntities = response.data.respuesta.result;
  },
  computed: {
    ...mapGetters('docDigital', [
      'documentType',
      'entity'
    ]),
    configuration() {
      return this.getFilterView(this.view);
    },
    filterView() {
      return this.getFilterView(this.view);
    }
  },
  methods: {
    ...mapActions('docDigital', [
      'fetchOptionsDocDigital'
    ]),
    async changeFilters(filters, onMounted) {
      console.log('changeFilters: this.rangeFrom', onMounted, this.rangeFrom, 'this.rangeUntil', this.rangeUntil);
      const rangeFromCreate = this.$moment(this.rangeFrom).format('DD-MM-YYYY');
      const rangeFromUntil = this.$moment(this.rangeUntil).format('DD-MM-YYYY');
      const fechaName = this.fechaName || 'fechaActualizacionDesde';
      const fechaUntilName = this.fechaUntilName || 'fechaFinCreacion';
      const defaultFilters = `${fechaName}:${rangeFromCreate}|${fechaUntilName}:${rangeFromUntil}`;
      this.currentFilters = filters;
      console.log('changeFilters: filters', onMounted, filters, defaultFilters);
      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;

      if (!onMounted) {
        const nonShareableFilters = [
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        console.log('changeFilters: queryFilters', onMounted, queryFilters, newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
